import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";

export const Route = createFileRoute("/admin/registrations")({ component: RegistrationsPage });

function RegistrationsPage() {
  const [rows, setRows] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  async function load() {
    const data = await api.registrations.list();
    setRows(data);
    setLoading(false);
  }
  useEffect(() => { load(); }, []);

  async function del(id: string) {
    if (!confirm("למחוק הרשמה זו?")) return;
    await api.registrations.delete(id);
    toast.success("נמחק");
    load();
  }

  return (
    <div>
      <h1 className="font-display text-3xl font-bold text-primary mb-6">הרשמות ({rows.length})</h1>
      {loading ? <div>טוען...</div> : rows.length === 0 ? (
        <p className="text-muted-foreground">אין עדיין הרשמות.</p>
      ) : (
        <div className="space-y-3">
          {rows.map((r) => (
            <div key={r.id} className="rounded-lg bg-card p-5 shadow-card border border-border">
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1">
                  <div className="flex items-center gap-3">
                    <h3 className="font-display text-lg font-bold text-primary">{r.parent_name}</h3>
                    <span className="text-xs text-muted-foreground">{new Date(r.created_at).toLocaleString("he-IL")}</span>
                  </div>
                  <div className="mt-2 grid gap-1 text-sm md:grid-cols-2">
                    <div><span className="text-muted-foreground">טלפון:</span> <span dir="ltr">{r.phone}</span></div>
                    {r.email && <div><span className="text-muted-foreground">אימייל:</span> {r.email}</div>}
                    <div><span className="text-muted-foreground">שם הבן:</span> {r.student_name}</div>
                    {r.student_age && <div><span className="text-muted-foreground">גיל/כיתה:</span> {r.student_age}</div>}
                  </div>
                  {r.message && <p className="mt-3 text-sm bg-secondary p-3 rounded">{r.message}</p>}
                </div>
                <Button size="icon" variant="ghost" onClick={() => del(r.id)}><Trash2 className="h-4 w-4 text-destructive" /></Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
